var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pagination" },
    [
      _c(
        "button",
        {
          attrs: { disabled: _vm.currentPage === 1 },
          on: {
            click: function($event) {
              return _vm.changePage(1)
            }
          }
        },
        [_vm._v("<<")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          attrs: { disabled: _vm.currentPage === 1 },
          on: {
            click: function($event) {
              return _vm.changePage(_vm.currentPage - 1)
            }
          }
        },
        [_vm._v(" < ")]
      ),
      _vm._v(" "),
      _vm._l(_vm.pagesToShow, function(page) {
        return _c(
          "button",
          {
            key: page,
            class: { active: page === _vm.currentPage },
            on: {
              click: function($event) {
                return _vm.changePage(page)
              }
            }
          },
          [_vm._v("\n        " + _vm._s(page) + "\n    ")]
        )
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          attrs: { disabled: _vm.currentPage === _vm.totalPages },
          on: {
            click: function($event) {
              return _vm.changePage(_vm.currentPage + 1)
            }
          }
        },
        [_vm._v(">")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          attrs: { disabled: _vm.currentPage === _vm.totalPages },
          on: {
            click: function($event) {
              return _vm.changePage(_vm.totalPages)
            }
          }
        },
        [_vm._v(">>")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cd0dc32", { render: render, staticRenderFns: staticRenderFns })
  }
}